import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkoutSpecialInstruction } from "redux/actions";
import "./special-comment.scss";
import CustomerDetails from "../CustomerDetails";

const SpecialComment = () => {
  const dispatch = useDispatch();

  const { checkoutInstruction, savePlaceOrder, isFollowedEbtPayment } = useSelector(({ checkout }) => checkout);

  const handleSpecialInstruction = (e) => {
    const { value } = e.target;
    dispatch(checkoutSpecialInstruction(value));
  };

  useEffect(() => {
    if (isFollowedEbtPayment && savePlaceOrder?.order_note) {
      dispatch(checkoutSpecialInstruction(savePlaceOrder?.order_note));
    }
  }, [isFollowedEbtPayment, savePlaceOrder?.order_note, dispatch])

  return (
    <>
    <div className="special-comment-section">
      <div className="form-control">
        <label>Add Special Instructions For Your Order</label>
        <textarea
          placeholder="Enter Notes.."
          onChange={handleSpecialInstruction}
          value={checkoutInstruction}
        ></textarea>
      </div>
    </div>
    <CustomerDetails />
    </>
  );
};
export default SpecialComment;
